import React from 'react'
import "../../App.css"

const Services = () => {
    return (
        <div>
            <h1 className="services">SERVICES</h1>
        </div>
    )
}

export default Services
